import Api from "./api.jsx";

import * as Constants from "../../../consts/Constants.js";

import auth from "../../auth/service";

const ADMIN_ROLE = 4601;

class CallsService {

	constructor(baseUrl) {
		this.api = new Api(baseUrl);
	}

	canAdmin() {
		return auth.hasRole(ADMIN_ROLE);
	}

	canApply() {
		return auth.isCitizen();
	}

}

export default new CallsService(Constants.FINAL_URL_CALLS_SERVICE);